module.exports = __webpack_public_path__ + "img/1557614067023159297.4001cbed.png";